import React, { useState, useEffect } from 'react';
import { HiMiniBellAlert } from "react-icons/hi2";
import { baseURL } from '../base_url';
import axios from 'axios';
import { Link, NavLink} from "react-router-dom";

const BellAlert = () => {
  const [alertCount, setAlertCount] = useState(0); // Example initial alert count
  const [openAlertWindow, setOpenAlertWindow] = useState(false); // Example initial alert count
  const [alertData, setAlertData] = useState([]);

  const loggedInUser = sessionStorage.getItem("tm_token");
  const foundUser = JSON.parse(loggedInUser);
  
  const handleBellClick = () => {
    // Handle bell icon click, e.g., show dropdown with details
    // You can add your logic here
    setAlertCount(0); // Reset alert count after clicking
    setOpenAlertWindow((prevOpen) => !prevOpen);
  };
  
  useEffect(() => {
    axios.get(baseURL + "/get_alert_warning?total=2&admin_id=" + foundUser['tm_id']).then((res) => {
      if(res.data.status === "1"){
        setAlertData(res.data.data)
      }
    });
  },[]);

  return (
    <div className="bell-alert-container" style={{marginRight:"30px"}}>
      <HiMiniBellAlert style={{ fontSize: 25, cursor: 'pointer',marginRight:"10px" }} onClick={handleBellClick}/>
      {/* <div className="bell-icon">
        <div className="alert-circle" style={{ background: alertCount > 0 ? 'red' : 'transparent' }}>
          {alertCount > 0 && <span className="alert-count">{alertCount}</span>}
        </div>
        <i className="fa fa-bell"></i>
      </div> */}
      {/* Dropdown component for alert details */}
      {openAlertWindow && (
        <div className="alert-dropdown" style={{color:"black",minWidth:"450px",padding:"0px"}}>
          <ul className='list-group'>
            <li className='list-group-item d-flex justify-content-end'><b style={{ cursor: 'pointer' }} onClick={handleBellClick}>X</b></li>
            {alertData.map((val, i) => (
              <>
              {val.type === "border_cross" ?
                <li className='list-group-item'>Warning: VIN <b>{val.vin}</b> is out of <b>State Border</b> and currently <b>{val.agreement_status}</b> at coordinates:(lat: {val.latitude},lng: {val.longitude}).<br/> R/A: <b>{val.agreement_number}</b><br/><i>{val.datetime}</i> </li>
                :<li className='list-group-item'>VIN <b>{val.vin}</b> is {val.response_data}</li>
              }
              </>
            ))}
            <li className='list-group-item d-flex justify-content-center' onClick={handleBellClick}><NavLink to="/r_alerts" ><b style={{ cursor: 'pointer',textDecoration:"underline" }}>View All</b></NavLink></li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default BellAlert;
